const handleImageUpload = async (file, minSize = 400, maxSize = 1280, maxBytes = 2000000) => {
  if (!file) return null;

  const readFile = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  try {
    const result = await readFile(file);
    const image = await loadImage(result);

    if (image.width < minSize || image.height < minSize) {
      throw new Error(`Image should be a minimum of ${minSize}×${minSize}px.`);
    }

    let finalImage;
    if (image.width > maxSize || image.height > maxSize || file.size > maxBytes) {
      let resizedImage = resizeAndCompressImage(image, maxSize, maxSize, 0.7);
      finalImage = resizedImage.toDataURL('image/jpeg');

      // Failsafe for oversized images
      if (finalImage.length > maxBytes) {
        resizedImage = resizeAndCompressImage(image, maxSize * 0.75, maxSize * 0.75, 0.5);
        finalImage = resizedImage.toDataURL('image/jpeg');
      }
    } else {
      finalImage = result;
    }

    return finalImage;
  } catch (error) {
    console.error(error.message);
    throw error;
  }
};

const loadImage = (dataUrl) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.src = dataUrl;
  });
};

const resizeAndCompressImage = (image, maxWidth, maxHeight, quality) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // Calculate new dimensions while maintaining aspect ratio
  let width = image.width;
  let height = image.height;
  if (width > maxWidth || height > maxHeight) {
    const scale = Math.min(maxWidth / width, maxHeight / height);
    width = width * scale;
    height = height * scale;
  }

  // Set canvas dimensions and draw the resized image
  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(image, 0, 0, width, height);

  // Return the canvas to compress and output as JPEG
  return canvas;
};

export { handleImageUpload, loadImage, resizeAndCompressImage };
